var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleTextBgColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67659 0H0.323412C0.144797 0 0 0.144797 0 0.323413V9.67659C0 9.8552 0.144797 10 0.323412 10H9.67659C9.8552 10 10 9.8552 10 9.67659V0.323413C10 0.144797 9.8552 0 9.67659 0Z",
    fill: "#2ADDBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79843 8.25755L4.21906 1.60279C4.24843 1.52183 4.32541 1.46826 4.41113 1.46826H5.5893C5.67542 1.46826 5.752 1.52183 5.78137 1.60279L8.202 8.25755C8.25041 8.39088 8.15161 8.53175 8.00994 8.53175H6.9393C6.85319 8.53175 6.77621 8.47779 6.74684 8.39644L6.30835 7.17739C6.27899 7.09644 6.2024 7.04207 6.11589 7.04207H3.8766C3.7901 7.04207 3.71272 7.09683 3.68375 7.17818L3.2528 8.39564C3.22383 8.47739 3.14684 8.53175 3.05994 8.53175H1.9897C1.84764 8.53175 1.74922 8.39088 1.79764 8.25755H1.79843ZM4.53375 5.61112H5.45121C5.59248 5.61112 5.69129 5.47104 5.64367 5.3381L5.18732 4.05675C5.12303 3.8758 4.86748 3.8754 4.8024 4.05596L4.34129 5.33731C4.29327 5.47064 4.39208 5.61112 4.53375 5.61112Z",
    fill: "#231E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleTextBgColorIcon);
export default __webpack_public_path__ + "static/media/StyleTextBgColorIcon.759413cda73c7d025d4496dd6f7fd402.svg";
export { ForwardRef as ReactComponent };